var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.174,
    height: 108,
    viewBox: "0 0 92.174 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "female",
    transform: "translate(-11.156 -2.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    transform: "translate(35.156 11.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M64,72.687V72.6h0Z",
    transform: "translate(-6.744 -8.998)",
    fill: "#2d3e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M54.255,48.511a2.383,2.383,0,1,0-1.658-.7A2.383,2.383,0,0,0,54.255,48.511Zm16.75,0a2.383,2.383,0,1,0-1.658-.7A2.552,2.552,0,0,0,71.005,48.511Z",
    transform: "translate(-5.2 -5.322)",
    fill: "#b07f4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M36.842,68.4h9.334V58.8a20.176,20.176,0,0,0,10.9,3.228h.174A20.176,20.176,0,0,0,68.16,58.8v9.683h17.1V30.278a28.185,28.185,0,0,0-28-28.178h-.174A28.224,28.224,0,0,0,29.165,30.278V68.4h7.677Zm2.966-34.9a5.063,5.063,0,0,1,5.06-5.06H69.644a5.063,5.063,0,0,1,5.06,5.06v7.939a17.549,17.549,0,0,1-3.489,10.469,20.346,20.346,0,0,1-2.966,3.141,17.352,17.352,0,0,1-21.984,0A16.718,16.718,0,0,1,43.3,51.913a17.549,17.549,0,0,1-3.489-10.469Zm63.509,74.326c-.785-4.536-2.617-14.22-3.053-15.528C98.257,86.2,93.11,83.231,87.614,80.963c-.7-.262-1.4-.611-2.094-.872-4.8-1.832-9.6-3.751-14.394-5.583a15.082,15.082,0,0,1-27.742,0c-4.8,1.832-9.6,3.751-14.394,5.583a21.309,21.309,0,0,0-2.094.872C21.4,83.231,16.341,86.2,14.248,92.3c-.436,1.221-2.181,10.992-3.053,15.528a1.817,1.817,0,0,0,.96,2.006,1.759,1.759,0,0,0,.96.262h88.2a1.759,1.759,0,0,0,.96-.262A2,2,0,0,0,103.317,107.832Z",
    fill: "#2d3e50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.e6784ec734261b06ce2423c5549f2876.svg";
export { ForwardRef as ReactComponent };